<div class="row intro">
    <div class="intro-sub">
        <div class="row website-name">Circular</div>
        <div class="row">
            <div class="col-md-4 col-md-offset-4 break-line"></div>
        </div>
        <div class="row description">An urban farming finance</div>
    </div>
</div>
<br>
<div class="container" style="height: 99vh;">
    <div class="row" style="height: 320px;">
        <div class="col-sm-1"></div>
        <div class="col-sm-5 text-center">
            <img style="height: 320px; width: 100%;" src="../../../assets/problem1.jpeg">
        </div>
        <div class="col-sm-5 text-center" style="align-self: center;">
            <h5 style="font-family: 'Fredoka One', cursive; font-size:30px;">Problem</h5>
            <p>
                We are unable to build the real world mitigation and adaptation projects fast enough!
            </p>
        </div>
    </div>
    <br>
    <div class="row" style="height: 320px;">
        <div class="col-sm-1"></div>
        <div class="col-sm-5 text-center" style="align-self: center;">
            <h5 style="font-family: 'Fredoka One', cursive; font-size:30px;">Opportunity</h5>
            <p>
                Improve the process to prepare, find, finance and ultimately to build the projects! Scale Ethreum
                ecosystem
                to the case!</p>
        </div>
        <div class="col-sm-5 text-center">
            <img style="height: 320px; width: 100%;" src="../../../assets/farming1.jpeg">
        </div>
    </div>
</div>
<div class="container" style="margin-top: 30px;">
    <div class="row" style="justify-content: center;">
        <h2 style="font-family: 'Fredoka One', cursive; font-size:42px;">VALUES</h2>
    </div>
    <div class="row">
        <hr style="border: 2px solid black; width: 100px;">
    </div>
    <br><br>
    <div class="row" style="height: 320px; margin-top: 30px;">

        <div class="col-sm-4 text-center">
            More projects in real world

        </div>
        <div class="col-sm-4 text-center">
            Resilient local economies

        </div>
        <div class="col-sm-4 text-center">
            Local water circulation, livelihoods, biodiversity and pollinators and amenities

        </div>
    </div>
</div>